export default "__VITE_ASSET__85f8b02e__"